import { getLevel } from '~/assets/services/url';

export default function ({ store, route }) {
    const { path } = route;
    store.commit('windowOptions/SET_LEVEL_PAGE_URL', getLevel(path));
}
